import { z } from 'zod';
/**
 * Аналитика расходов проекта (страница «Аналитика»).
 * Считается на сервере по оплаченным расходам (status = 'PAID') активного проекта.
 * Суммы приведены к валюте проекта через amount * COALESCE(exchange_rate, 1).
 */
export const analyticsMaxExpenseSchema = z
    .object({
    date: z.string(),
    amount: z.number(),
    category: z.string().nullable(),
    description: z.string().nullable(),
})
    .nullable();
export const analyticsSummarySchema = z.object({
    currency: z.string(),
    totalAmount: z.number(),
    expenseCount: z.number(),
    averageExpense: z.number(),
    medianExpense: z.number(),
    firstExpenseDate: z.string().nullable(),
    lastExpenseDate: z.string().nullable(),
    accountingDays: z.number(),
    averagePerDay: z.number(),
    maxExpense: analyticsMaxExpenseSchema,
});
export const analyticsCategorySchema = z.object({
    // null — расходы без категории, фронт локализует подпись
    category: z.string().nullable(),
    amount: z.number(),
    sharePercent: z.number(),
    expenseCount: z.number(),
    averageExpense: z.number(),
});
export const analyticsTimePointSchema = z.object({
    // ISO-дата: для daily — день, для weekly — начало недели
    date: z.string(),
    amount: z.number(),
    expenseCount: z.number(),
    cumulativeAmount: z.number(),
});
export const analyticsTopExpenseSchema = z.object({
    date: z.string(),
    category: z.string().nullable(),
    amount: z.number(),
    description: z.string().nullable(),
});
export const projectAnalyticsSchema = z.object({
    // ISO-время, когда снапшот был посчитан (кэш обновляется не чаще раза в сутки)
    generatedAt: z.string(),
    summary: analyticsSummarySchema,
    categories: z.array(analyticsCategorySchema),
    daily: z.array(analyticsTimePointSchema),
    weekly: z.array(analyticsTimePointSchema),
    topExpenses: z.array(analyticsTopExpenseSchema),
});
//# sourceMappingURL=analytics.js.map